import { render } from "./areaEvaAgeSubjectEchart.vue?vue&type=template&id=44755f99&scoped=true"
import script from "./areaEvaAgeSubjectEchart.vue?vue&type=script&lang=js"
export * from "./areaEvaAgeSubjectEchart.vue?vue&type=script&lang=js"

import "./areaEvaAgeSubjectEchart.vue?vue&type=style&index=0&id=44755f99&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44755f99"]])

export default __exports__